module.exports = __webpack_public_path__ + "static/img/10.2018e8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/10.png
// module id = eLEE
// module chunks = 0